import { useState } from 'react';

import { getConfig } from '../../utils/getConfig.js';
import { Checkout } from './components/Checkout/Checkout.js';
import { CheckoutFetcher } from './components/Checkout/CheckoutFetcher.js';
import { PricingTable } from './components/PricingTable.js';
import { Plan, PriceID, SubscriptionModuleMode } from './types.js';
import { getPlans } from './utils/getPlans.js';

type Props = {
  plans?: Plan[];
  mode: SubscriptionModuleMode;
  redirectURL: string;
  isMcKissockBundlePricingEnabled?: (params: { interval: 'month' | 'year' }) => boolean;
  onPlanSelect?: () => void;
  onFinish: () => void;
};

export function SubscriptionModule({
  plans = getPlans(),
  mode,
  redirectURL,
  isMcKissockBundlePricingEnabled,
  onPlanSelect,
  onFinish,
}: Props) {
  const [planInfo, setPlanInfo] = useState<{
    priceID: PriceID;
    interval: 'month' | 'year';
  } | null>(null);

  if (planInfo) {
    const { priceID, interval } = planInfo;
    const initialPromoCode = isMcKissockBundlePricingEnabled?.({ interval })
      ? getConfig('STRIPE_MCKISSOCK_PROMO_CODE')
      : undefined;

    return (
      <CheckoutFetcher
        priceID={priceID}
        isTrial={mode === 'legacy-new-user-trial'}
        initialPromoCode={initialPromoCode}
      >
        {({ promoCode, pricingBreakdown }) => (
          <Checkout
            priceID={priceID}
            redirectURL={redirectURL}
            initialPromoCode={promoCode}
            initialPricingBreakdown={pricingBreakdown}
            mode={mode}
            onCheckoutComplete={onFinish}
          />
        )}
      </CheckoutFetcher>
    );
  }

  return (
    <PricingTable
      plans={plans}
      showTrial={mode === 'legacy-new-user-trial'}
      onPlanSelect={({ priceID, interval }) => {
        setPlanInfo({ priceID, interval });
        onPlanSelect?.();
      }}
    />
  );
}
